// Import necessary libraries
import React from 'react';
import { StyledFooter, ScrollingText } from '../styles/StyledFooterComponents';

// Footer component
const Footer = () => {
    return (
        <StyledFooter>
            <ScrollingText>
                WELCOME TO THE FUTURE ARCHIVE PROJECT MADE BY RAYMOND WANG ONE DAY SOMETHING IN HERE WILL BECOME ACTUAL ARCHIVE THAT BENEFIT THE WORLD IN SOME WAY I WOULD LOVE TO CONNECT WITH YOU FEEL FREE TO REACH OUT IN THE CONTACT PAGE THANK YOU FOR VISITING
            </ScrollingText>
        </StyledFooter>
    );
};

export default Footer;
